<p-dialog
  [(visible)]="visibleDialog"
  [style]="{ width: '450px' }"
  [modal]="true"
  [resizable]="false"
  [closable]="false"
  [closeOnEscape]="true"
  [draggable]="false"
  (onHide)="closeDialog()">
  <div class="flex flex-col justify-center items-center p-5">
    <p class="text-center mb-4">
      {{ "passwordMessages.resetExpired" | translate }}
    </p>
    <button
      pButton
      [label]="'passwordMessages.ok' | translate"
      (click)="closeDialog()"
      class="bg-primary text-white"></button>
  </div>
</p-dialog>
